export default {
  messages: {
    actions: {
      add: 'Hinzufügen',
      apply: 'Anwenden',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      editRevisions: 'Revisionen',
      new: 'Erstellen',
      reset: 'Zurücksetzen',
      save: 'Speichern',
    },
    confirmations: {
      delete: 'Möchten Sie {name} wirklich unwiederbringlich löschen?',
      softDelete: 'Möchten Sie {name} wirklich löschen?',
    },
    toasts: {
      deleted: '{name} wurde gelöscht',
      undeleted: '{name} wurde wieder hergestellt',
    },
    attachmentSources: {
      local: 'Upload',
      remote: 'Link',
    },
    attachmentTypes: {
      document: 'Dokument',
      image: 'Bild',
      video: 'Video',
    },
    breadcrumbs: {
      edit: 'Bearbeiten',
      editRevision: 'Revision bearbeiten',
      new: 'Erstellen',
      newRevision: 'Revision erstellen',
      revisions: 'Revisionen',
    },
    colors: {
      '#000000': 'Schwarz',
      '#6C6C6C': 'Grau, Antrhrazit',
      '#D0D0D0': 'Silber',
      '#FFFFFF': 'Weiß, Transparent',
      '#D71F1F': 'Rot',
      '#FF9A1E': 'Orange',
      '#FECB00': 'Gelb',
      '#FF0066': 'Pink',
      '#FFC0CB': 'Rosa',
      '#E7CDB0': 'Beige, Gold',
      '#B76A40': 'Braun',
      '#89D63D': 'Grün',
      '#D6FFD6': 'Mint',
      '#00A1DE': 'Blau',
      '#5DF6FF': 'Türkis',
      '#B357B3': 'Lila',
    },
    productCustomizabilities: {
      NONE: 'Nicht anpassbar',
      PARTIAL: 'Teilweise anpassbar',
      FULL: 'Vollständig anpassbar',
    },
    dialogs: {
      ok: 'OK',
      cancel: 'Abbrechen',
    },
    energyEfficiencyClasses: {
      aTriplePlus: 'A+++',
      aDoublePlus: 'A++',
      aPlus: 'A+',
      a: 'A',
      b: 'B',
      c: 'C',
      d: 'D',
      e: 'E',
      f: 'F',
      g: 'G',
    },
    fields: {
      family_number: 'Family Number',
      r_id: 'Revision ID',
      active: 'Aktiv',
      admin: 'Administrator',
      aliases: 'Synonyme',
      altName: 'Alternativname',
      alwaysDisplayed: 'Immer Angezeigt?',
      amount: 'Anzahl',
      ancestors: 'Eltern',
      appSetup: 'App-gestützte Einrichtung',
      apply: 'Anwenden',
      articleNumber: 'Artikelnummer',
      attachments: 'Dateien',
      band24: '2.4 GHz',
      band5: '5 GHz',
      batteryPowered: 'Batteriebetrieb',
      body: 'Text',
      brand: 'Marke',
      brandCrassCompatible: 'Für Geräte anderer Hersteller nutzbar',
      brandCrossCompatible: 'Für Geräte anderer Hersteller nutzbar',
      buttonCount: 'Anzahl belegbare Tasten',
      cable: 'Mit Zuleitungskabel',
      categories: 'Kategorien',
      category: 'Kategorie',
      categoryNumber: 'Kategorienummer',
      cloudData: 'Speicherung in Hersteller-Cloud',
      code: 'Farbcode',
      coffeeMaker: 'Kaffeevollautomaten',
      color: 'Farbe',
      coloredLight: 'Mit Farblicht',
      comment: 'Verwendungszweck',
      commonCharger: {
        possible: 'Gerät ist Ladegerät fähig?',
        included: 'Gerät wird mit Ladegerät geliefert',
        minWattage: 'Minimale Ladeleistung',
        maxWattage: 'Maximale Ladeleistung',
        usbPd: 'Ladegerät kann USB PowerDelivery',
      },
      compatibleAppVersions: 'Kompatible Apps',
      compatibleBaseStations: 'Kompatible Zentralen',
      connection: 'Anschlussart',
      connectionRequired: 'Anbindung an Herstellersystem erforderlich',
      connectionRequiredLabel:
        'Anbindung an Herstellersystem erforderlich (Text)',
      consumptionMeasuring: 'Mit Verbrauchsmessung',
      contentType: 'Dateityp',
      contract: 'Vertrag',
      contractDuration: 'Vertragslaufzeit',
      contractNumber: 'Vertragsnummer',
      contractRevisions: 'Vertrags-Revisionen',
      cooktop: 'Kochfelder',
      createdAt: 'Angelegt um',
      customizability: 'Anpassbarkeit',
      dect: 'DECT ULE',
      deliveredItems: 'Lieferumfang',
      deliveryLeadTime: 'Lieferzeit',
      description: 'Beschreibung',
      designArtist: 'Künstler',
      designCategories: 'Kategorien',
      designImage: 'Bild',
      designName: 'Design-Name',
      details: 'Details',
      dimensions: 'Maße',
      dimFunction: 'Mit Dimmfunktion',
      dimmable: 'dimmbar',
      dimming: 'Mit Dimmfunktion',
      dishwasher: 'Geschirrspüler',
      display: 'Mit Display',
      distinctPower: 'Mit eigener Stromversorgung',
      documents: 'Dokumente',
      ean: 'EAN',
      eanList: 'EANs',
      email: 'E-Mail-Adresse',
      energyDocument: 'Energie-Document',
      energyEfficiency: 'Energieeffizienz',
      energyEfficiencyClass: 'Energieeffizienzklasse',
      energyLabelImage: 'Energie-Label',
      errorsCount: 'Fehler',
      exhaustHood: 'Dunstabzugshauben',
      expiredAt: 'Abgelaufen',
      extension: 'Erweiterung nötig',
      family: 'Familie',
      familyNumber: 'Familiennummer',
      features: 'Features',
      file: 'Datei',
      fileName: 'Dateiname',
      finishedAt: 'Beendet',
      flushMounted: 'Unterputz',
      forHeater: 'Für Heizkörper',
      forUnderfloorHeater: 'Für Fußbodenheizung',
      fridgeFreezer: 'Kühl- und Gefrierschränke',
      guestWifi: 'Unterstützt Gäste-WLAN',
      heroImage: 'Hero Image',
      hiddenInstallation: 'Verdeckter Einbau',
      homeMaticBidcos: 'HomeMatic / BidCoS',
      homeMaticIp: 'Homematic IP',
      homeMaticIpLabel: 'Homematic IP (Text)',
      id: 'ID',
      image: 'Bild',
      importer: 'Importer',
      indoor: 'Innenbereich',
      insertedAt: 'Erstellt',
      integratedHdd: 'Integrierter Festplattenrekorder',
      integratedMicrophone: 'Mit integriertem Mikrofon für Sprachsteuerung',
      inWall: 'Unterputz',
      ipWifi: 'IP / WLAN / SIM',
      issuedAt: 'Ausgestellt',
      keywords: 'Schlüsselwörter',
      lan: 'LAN',
      lanPorts: 'Anzahl LAN-Anschlüsse',
      legalTexts: 'Rechtstexte',
      lightsensor: 'Mit Helligkeits-/Lichtsensor',
      list: 'Gelistet',
      logo: 'Logo',
      magentaCloudData: 'Speicherung in MagentaCLOUD',
      magnetic: 'Magnetisch',
      manufacturerContact: 'Hersteller Kontakt',
      manufacturerContactEu: 'EU Hersteller Kontakt',
      manufacturerPartNumber: 'Hersteller Teilenummer',
      manufacturerProductCode: 'Manufacturer ProductCode',
      markenschalterCompatible: 'Für Markenschalter geeignet',
      mashWifiSupport: 'Unterstützt Mesh WLAN',
      maxOrderableAmount: 'Bestellbare Anzahl',
      media: 'Medien',
      memory: 'Arbeitsspeicher',
      meshSupport: 'Unterstützt Mesh WLAN',
      microphone: 'Mikrofon',
      mobil: 'flexibel/ mobil',
      mobile: 'flexibel/ mobil',
      model: 'Modell',
      mshGroupControl: 'Unterstützt Gruppenkontrolle in MSH',
      mshPlaylist: 'Unterstützt Playlists in MSH',
      mshSpeechControl: 'Unterstützt Sprachsteuerung in MSH',
      multiFunctionButtons: 'Mehrfachbelegung je Taste',
      multipleColorsAvailable: 'mehrere Farben erhältlich',
      name: 'Name',
      noSocket: 'Ohne Fassung / LED nicht austauschbar',
      offer: 'Angebot',
      offset: 'Mit Offset*',
      onWall: 'Aufputz',
      optical: 'Optisch',
      ordered: 'Sortiert',
      origin: 'Datenquelle',
      outdoor: 'Außenbereich',
      ovenSteamer: 'Backöfen und Dampfgarer',
      path: 'Pfad',
      personRecognition: 'Erkennung menschlicher Bewegungen',
      petCompatible: 'Störungssicher bei Haustieren',
      plainBody: 'Text',
      popularity: 'Popularität',
      position: 'Position',
      powerCord: 'Stromanschluss',
      powerSupply: 'Mit eigener Stromversorgung',
      prices: 'Preise',
      priceExtraInformation: 'Preissternchen Information',
      priority: 'Priorität',
      product: 'Produkt',
      productFamilyRevisions: 'Produktfamilien-Revisionen',
      productRevisions: 'Produkt-Revisionen',
      provider: 'Provider',
      pxsdbSecureBufferDisabled: 'Sicherheitspuffer ignorieren (PXSDB)',
      reachEnhencer: 'Erhöht die Funk-Reichweite',
      remoteAttachment: 'Remote?',
      remoteControl: 'Mit Fernbedienung',
      remoteControlled: 'Mit Fernbedienung',
      repeater: 'Erhöht die Funk-Reichweite',
      role: 'Rolle',
      schellenberg: 'Schellenberg',
      schellenbergLabel: 'Schellenberg (Text)',
      scope: 'Umfang',
      sdBuffered: 'MicroSD Karte für Zwischenspeicherung benötigt',
      sdMemoryCard: 'Speicherung auf MicroSD Karte',
      securityInformationUrl: 'URL zum Sicherheitsinformationsblatt',
      selectors: 'Selektionseigenschaften',
      sensitivityAdjustment: 'Einstellbare Empfindlichkeit',
      seperateIpRadio: 'Separat nutzbares Internetradio',
      shortUsp: 'USPs (gekürzt)',
      size: 'Größe',
      slatControl: 'Mit Lamellensteuerung',
      slug: 'Schlüssel',
      smarthomeSpeaker: 'Als SmartHome Lautsprecher verwendbar*',
      smartHub: 'Als SmartHome Zentrale nutzbar',
      smartSocketCount: 'Anzahl smarte Steckplätze',
      socketE14: 'Fassung E14',
      socketE26: 'Fassung E26 - US',
      socketE27: 'Fassung E27',
      socketGu10: 'Fassung GU10',
      socketGu5_3: 'Fassung GU5.3',
      startedAt: 'Begonnen',
      state: 'Status',
      stationary: 'Fest montiert',
      status: 'Status',
      stock: 'Lagerbestand',
      stocks: 'Lagerbestände',
      storage: 'Speicherplatz',
      streamingOnly: 'Nur Streaming',
      style: 'Produktstil',
      summaryTexts: 'Zusammenfassung',
      swappableHdd: 'Wechsel-Festplatte',
      tags: 'Tags',
      tamperProtection: 'Sabotageschutz*',
      tenant: 'Mandant',
      tenants: 'Mandanten',
      thumb: 'Thumbnail',
      timingInfo: 'Schrittlänge',
      token: 'Schlüssel',
      totalStock: 'Lagerbestand',
      type: 'Typ',
      uhdtv: 'Unterstützt Ultra-HD TV',
      unit: 'Einheit',
      updatedAt: 'Aktualisiert',
      url: 'URL',
      usbPorts: 'Anzahl USB-Steckplätze',
      usbPower: 'Stromversorgung über USB',
      usbPowered: 'Stromversorgung über USB',
      usps: 'USPs',
      vacuumRobot: 'Saugroboter',
      validFrom: 'Gültig ab',
      validity: 'Zeitraum',
      validUntil: 'Gültig bis',
      variantName: 'Variantenname',
      voiceCommands: 'Unterstützt Sprachsteuerung',
      wallMounted: 'Aufputz',
      washerDryer: 'Waschmaschinen und Trockner',
      weight: 'Gewicht',
      whineCabinet: 'Weinschränke',
      wpsSupport: 'WPS-Verbindungsmöglichkeit',
      zigbee: 'ZigBee',
      zigbeeLabel: 'ZigBee (Text)',
      stockSkipUpdate: 'Bestand-Import deaktivieren',
      stockSkipUpdateFrom: 'Deaktivieren von',
      stockSkipUpdateTo: 'Deaktivieren bis',
    },
    fieldsets: {
      attachments: 'Bilder',
      basicFields: 'Basisdaten',
      categories: 'Kategorien',
      commonCharger: 'Common Charger',
      content: 'Inhalt',
      design: 'Stil/Design',
      details: 'Details',
      documents: 'Dokumente',
      energy: 'Energie',
      features: 'Features',
      legalTexts: 'Rechtstexte',
      manufacturerContact: 'Herstellerkontakte',
      media: 'Medien',
      prices: 'Preise',
      productStocks: 'Lagerbestände',
      publications: 'Veröffentlichung',
      selectors: 'Selektionseigenschaften',
      seo: 'Suchmaschinenoptimierung',
      validity: 'Gültigkeit',
      skipStockAvailabilityImport: 'Bestand-Import deaktivieren',
    },
    hints: {
      noOptions: 'Keine Einträge vorhanden.',
      noResults: 'Keine Suchergebnisse gefunden.',
      select: 'Auswählen',
      deselect: 'Entfernen',
      selected: 'Ausgewählt',
    },
    importers: {
      BRODOS_ARTICLES: 'Brodos: Artikeldaten',
      BRODOS_ATTACHMENTS: 'Brodos: Bilddownload',
      BRODOS_BUNDLES: 'Brodos: Bundle-Daten',
      BRODOS_CATEGORIES: 'Brodos: Kategoriedaten',
      BRODOS_DYNAMIC_DATA: 'Brodos: Bewegungsdaten',
      BRODOS_PRODUCT_FAMILIES: 'Brodos: Produktfamiliendaten',
      BRODOS_PRODUCTS: 'Brodos: Produktdaten',
      BRODOS: 'Brodos: Vollständiger Import',
      PXSDB_ARTICLES: 'Telekom: Artikeldaten',
      TELEKOM_PRODUCT_AVAILABILITIES: 'Telekom: Verfügbarkeiten',
    },
    paymentFrequencies: {
      monthly: 'monatlich',
      onetime: 'einmalig',
    },
    priceTypes: {
      default: 'Normalpreis',
      was: 'Streichpreis',
    },
    providers: {
      BRODOS: 'Brodos AG',
      TELEKOM: 'Telekom Deutschland GmbH',
      TVPP: 'Telekom Vertriebspartner-Portal (TVPP)',
    },
    placeholder: {
      file: 'Wähle eine Datei aus',
      select: 'Bitte auswählen',
    },
    titles: {
      editRevision: 'Revision bearbeiten',
      newRevision: 'Revision erstellen',
    },
    units: {
      dimensions: {
        mm: 'mm',
        cm: 'cm',
      },
      deliveryLeadTimes: {
        singular: {
          days: 'Tag',
          weeks: 'Woche',
        },
        plural: {
          days: 'Tage',
          weeks: 'Wochen',
        },
      },
      duration: {
        months: 'Monate',
      },
      memory: {
        b: 'Bytes',
        kb: 'kB',
        mb: 'MB',
        gb: 'GB',
        tb: 'TB',
      },
      weight: {
        g: 'g',
        kg: 'kg',
      },
    },
    validationErrors: {
      blank: 'darf nicht leer sein',
      confirmation: 'stimmt nicht überein',
    },
  },
  dateTimeFormats: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  numberFormats: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    },
  },
};



// WEBPACK FOOTER //
// ./locales/de.js